import { type SourcePlugin } from 'src/types/segment';

declare global {
  interface Window {
    Shopify?: any;
    woocommerce_params?: any;
    zid?: any;
    salla?: any;
    Salla?: any;
    checkout?: {
      imageTemplate?: string;
    };
    cart?: {
      add: any;
      update: any;
      remove: any;
    };
  }
}

export const getSourcePlugin = (): SourcePlugin | undefined => {
  switch (true) {
    case !!window.Shopify:
      return 'shopify';
    case !!window.woocommerce_params:
      return 'woo';
    case !!window.zid:
      return 'zid';
    case !!(window.salla || window.Salla):
      return 'salla';
    case !!(
      window.checkout && window.checkout?.imageTemplate?.includes('Magento')
    ):
      return 'magento2';
    case !!(
      window.cart &&
      window.cart.add &&
      window.cart.update &&
      window.cart.remove
    ):
      return 'opencart';
    default:
      return undefined;
  }
};
